export const WIRE_TEMPLATES_CONTAINER_TAG_NAME = 'wire-templates-container';
